/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../components/ServicesLayout';
import PaymentStatus from './PaymentStatus';
import { isUserLoggedIn, fetchClaim, validateClaimOwnership, fetchDeliveryMethods, fetchPaymentMethods, fetchDistricBankAccounts } from '../../lib/utils';

const title = 'Status opłaty';

export default {

  path: '/paymentStatus/:jobID',

  async action(ctx) {
    const { params, store, query } = ctx;

    // get store
    const state = await store.getState();

    // checks is u're logged in
    const isUserLogged = isUserLoggedIn(state, query);
    if (!(isUserLogged === true)) {
      return isUserLogged;
    }
    // fetch job details url
    const claim = await fetchClaim(params.jobID);

    // if there is no claim with this job id then return to error page
    if (!claim) return null;

    // validates claim ownership
    if (!validateClaimOwnership(claim, state)) return { redirect: '/' };

    // fetch payment and delivery methods

    const deliveryMethods = await fetchDeliveryMethods(claim.teryt);
    const paymentMethods = await fetchPaymentMethods(claim.teryt);
    if (paymentMethods.fk_method === null || paymentMethods.fk_method === undefined) {
      paymentMethods.fk_method = 0;
    }
    let bankAccounts = await fetchDistricBankAccounts(claim.teryt);
    if (!bankAccounts) {
      bankAccounts = ['brak'];
    }
    return {
      title,
      component: <ServicesLayout>
        <PaymentStatus
          title={title}
          {...params}
          claim={claim}
          user={state.user}
          deliveryMethods={deliveryMethods}
          {...paymentMethods}
          {...bankAccounts}
        /></ServicesLayout>,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/paymentStatus/index.js